import { Modal } from "bootstrap";
import Carousel from "./carousel";
import { displayConfetti } from "../modules/utils";

export default class BadgeModal {
  constructor(element) {
    this.element = element;
    this.url = this.element.dataset.url;

    this.badgeInput = this.element.querySelector(".js-badge-modal-input");
    this.carouselTarget = this.element.querySelector(".js-badges-carousel");

    this.initialize();
  }

  initialize() {
    this.modalInstance = Modal.getInstance(this.element);

    this.modalInstance._element.addEventListener("shown.bs.modal", () => {
      this.submitBadgeSeen();
      this.initializeCarousel();

      displayConfetti(this.element, {
        scalar: 1.5,
        particleCount: 360,
        spread: 360,
        ticks: 60,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
      });
    });
  }

  submitBadgeSeen() {
    const formData = new FormData();
    formData.append("badge_ids", this.badgeInput.value);

    fetch(this.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    });
  }

  initializeCarousel() {
    if (this.carouselTarget) {
      const carouselOptions = {
        autoHeight: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      };

      new Carousel(this.carouselTarget, carouselOptions);
    }
  }
}
